module.exports = __webpack_public_path__ + "img/delete-grey.82b0b100.svg";